import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { LorenUtilsService } from "../../services/loren-utils-service/loren-utils.service";
import { Language } from "../../enums/language.enum";

@Injectable()
export class ClientLanguageInterceptor implements HttpInterceptor {
  private readonly CLIENT_LANGUAGE_HEADER_KEY = "x-client-language";

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const cloned = request.clone({
      headers: request.headers.set(
        this.CLIENT_LANGUAGE_HEADER_KEY,
        LorenUtilsService.getLastSelectedLanguage() || Language.BG
      ),
    });

    return next.handle(cloned);
  }
}
